import 'core-js/fn/map';
import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';
import 'core-js/fn/number/parse-float';



// WEBPACK FOOTER //
// ./src/polyfills.js